'use client';

import { createContext, useContext, ReactNode } from 'react';
import { BrandContextData } from '@/components/Layout/types';

// Define the shape of our layout context, or null if uninitialized
const LayoutContext = createContext<BrandContextData | null>(null);

interface LayoutProviderProps {
  contextData: BrandContextData;
  children: ReactNode;
}

export const LayoutProvider = ({ contextData, children }: LayoutProviderProps) => {
  return <LayoutContext.Provider value={contextData}>{children}</LayoutContext.Provider>;
};

export const useLayoutContext = () => {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error('useLayoutContext must be used within a LayoutProvider');
  }
  return context;
};
